/* eslint-disable react/no-unescaped-entities */
import React from "react";
import { InviteForm } from "src/components/Email/InviteForm";
import { PsModal } from "src/components/General/Modal";
import { CognitoSession } from "src/models/CognitoSession";

export interface InviteProps {
  session: CognitoSession;
}

export const Invite: React.FunctionComponent<InviteProps> = (props: InviteProps) => {
  const [inviteModal, setInviteModal] = React.useState(false);
  const toggleInviteModal = (): void => {
    setInviteModal(!inviteModal);
  };
  return (
    <div className="invite-friends">
      If you're benefiting from our service, please{" "}
      <a className="cursor-pointer" onClick={toggleInviteModal}>
        invite your friends to join us!
      </a>
      <PsModal title="Invite your friends" visible={inviteModal} toggleCb={toggleInviteModal}>
        <InviteForm session={props.session} cb={toggleInviteModal} />
      </PsModal>
    </div>
  );
};
